export default __webpack_public_path__ + "static/media/soca.74ca94e0.png";